// Shared helpers for commentary rendering (live and summary)

// Import icons directly for the bundler to handle
import ballIcon from '/src/assets/messages/ball.png';
import yellowCardIcon from '/src/assets/messages/card-yellow.png';
import redCardIcon from '/src/assets/messages/card-red.png';
import substitutionIcon from '/src/assets/messages/sub.png';
import injuryIcon from '/src/assets/messages/injury.png';

export function highlightEmphasis(text, emphasisArray) {
    if (!text) return '';
    let highlightedText = text;
    (emphasisArray || []).forEach(term => {
        if (term) {
            const regex = new RegExp(`\\b(${term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')})\\b`, 'gi');
            highlightedText = highlightedText.replace(regex, `<strong>$1</strong>`);
        }
    });
    return highlightedText;
}

export function getEmphasisStyles(emphasis) {
    const baseStyles = { lineHeight: '1.5', margin: '2px 0' };
    switch (emphasis) {
        case 'italic':
            return { ...baseStyles, fontStyle: 'italic', opacity: 0.9 };
        case 'bold':
            return { ...baseStyles, fontWeight: 'bold', fontSize: '1.05em' };
        case 'celebration':
            return { ...baseStyles, fontWeight: 'bold', fontSize: '1.1em', color: '#fbbf24', textShadow: '0 0 3px rgba(251,191,36,0.5)' };
        case 'subdued':
            return { ...baseStyles, opacity: 0.8, fontSize: '0.95em' };
        case 'metadata':
            return { ...baseStyles, fontSize: '0.9em', fontStyle: 'italic', opacity: 0.7, color: '#94a3b8' };
        default:
            return baseStyles;
    }
}

export const eventIcons = {
    'GOAL': ballIcon,
    'PENALTY_GOAL': ballIcon,
    'SAVE': ballIcon,
    'SHOT_OFF_TARGET': ballIcon,
    'SHOT_BLOCKED': ballIcon,
    'PASS_KEY': ballIcon,
    'SOLO_RUN_SETUP': ballIcon,
    'CHANCE_CREATED': ballIcon,
    'DANGEROUS_ATTACK': ballIcon,
    'PRESSURE_BUILDING': ballIcon,
    'YELLOW_CARD': yellowCardIcon,
    'RED_CARD': redCardIcon,
    'SUBSTITUTION': substitutionIcon,
    'INJURY': injuryIcon,
};

export const highImpactEvents = [
    'GOAL',
    'PENALTY_GOAL',
    'SAVE',
    'SHOT_BLOCKED',
    'PASS_KEY',
    'SOLO_RUN_SETUP',
    'CHANCE_CREATED',
    'DANGEROUS_ATTACK'
];

export const mediumImpactEvents = [
    'SHOT_OFF_TARGET',
    'PRESSURE_BUILDING'
];

export const specialEvents = [
    ...highImpactEvents,
    ...mediumImpactEvents,
    'RED_CARD',
    'YELLOW_CARD',
    'SUBSTITUTION',
    'INJURY'
];

export function getEventRowClasses(eventType) {
    if (!eventType || !specialEvents.includes(eventType)) {
        return [];
    }

    const classes = [`event-${eventType.toLowerCase()}`];
    if (highImpactEvents.includes(eventType)) {
        classes.push('event-high-impact');
    } else if (mediumImpactEvents.includes(eventType)) {
        classes.push('event-medium-impact');
    }

    return classes;
}

export function formatCommentaryMinute(event = {}) {
    const rawMinute = event.formal_minute ?? event.formalMinute ?? event.minute ?? 0;
    const minuteText = String(rawMinute).trim();

    if (!minuteText) {
        return "0'";
    }

    if (minuteText.endsWith("'") || ['HT', 'FT'].includes(minuteText.toUpperCase())) {
        return minuteText;
    }

    return `${minuteText}'`;
}
